import { render } from "./profile.vue?vue&type=template&id=33793d93&scoped=true&ts=true"
import script from "./profile.vue?vue&type=script&lang=ts"
export * from "./profile.vue?vue&type=script&lang=ts"

import "./profile.vue?vue&type=style&index=0&id=33793d93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33793d93"]])

export default __exports__